import React from 'react';

import {
  CACHE_KEY_LIST_HISTORIAN_OFFICES,
  ROUTE_PATH_HISTORIAN_OFFICES, SECURITY_KEY_CNAE_HISTORIAN_OFFICES,
  TRANSLATION_PREFIX_HISTORIAN_OFFICES
} from '@/modules/configuration/contants/historianOffices';
import {columns} from '@/modules/configuration/contants/historianOffices.columns';
import {filters} from '@/modules/configuration/contants/historianOffices.filters';
import HistorianOfficesApiService from '@/modules/configuration/services/HistorianOfficesApiService';
import {createEntityContainer} from '@/utils/createEntityContainer';

import HistorianOfficesBulkAction from '../components/HistorianOfficesBulkAction';

export const {
  useList: useHistorianOfficesList,
  ContainerList: HistorianOfficesList,
  useTablePagination: useHistorianOfficesPagination
} = createEntityContainer(
  {
    module: CACHE_KEY_LIST_HISTORIAN_OFFICES,
    service: HistorianOfficesApiService.search,
    route: ROUTE_PATH_HISTORIAN_OFFICES,
    useCreatePath: true,
    translation: 'historian',
    translationPrefix: TRANSLATION_PREFIX_HISTORIAN_OFFICES,
    entityName: SECURITY_KEY_CNAE_HISTORIAN_OFFICES,
    filters,
    columns,
    breadcrumbName: 'name',
    // eslint-disable-next-line react/display-name
    selectedActions: (itemsSelected) => <HistorianOfficesBulkAction {...itemsSelected}/>
  }
);
